import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { CallState } from '@lcs/shared/api';
import { Store, select } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { LcsDialogService } from 'src/app/common-components/dialog/dialog.service';
import { FormComponent } from 'src/app/common-components/forms-base/form-component.interface';
import { LocationDetailFormService } from '../../location-details/services/location-detail-form.service';
import { createLocation, createLocationAndAddAnother } from '../state/add-location.actions';
import { getAddLocationCallState } from '../state/add-location.selectors';
import { AddLocationViewComponent } from '../views/add-location-view.component';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    providers: [LocationDetailFormService],
    selector: 'ndt-add-location',
    styleUrls: ['./add-location.component.scss'],
    templateUrl: './add-location.component.html',
    standalone: false
})
export class AddLocationComponent implements OnInit, OnDestroy, FormComponent {
   @ViewChild(AddLocationViewComponent) addLocationViewComponent: AddLocationViewComponent;

   callState: Observable<CallState>;

   form: UntypedFormGroup;

   private destroyed$ = new Subject<void>();

   constructor(
      protected store: Store,
      protected formService: LocationDetailFormService,
      private dialogService: LcsDialogService
   ) {
      this.callState = this.store.pipe(select(getAddLocationCallState));
   }

   ngOnInit(): void {
      this.form = this.formService.form;

      this.form.patchValue({
         country: 'US',
      });
   }

   ngOnDestroy(): void {
      this.destroyed$.next();
   }

   onCloseClick(): void {
      this.dialogService.close();
   }

   onCreate(): void {
      if (this.form.valid) {
         this.store.dispatch(
            createLocation({
               location: this.formService.getValue(null),
            })
         );
      }
   }

   onCreateAndAddAnother(): void {
      if (this.form.valid) {
         this.store.dispatch(
            createLocationAndAddAnother({
               location: this.formService.getValue(null),
            })
         );
      }
   }
}
